import { FontEnum } from "../../../../SharedComponents/utils/enums/FontEnum";
import TableHideArrowIconSVG from "../../../assets/icons/svg/TableHideArrowIconSVG";
import TableShowArrowIconSVG from "../../../assets/icons/svg/TableShowArrowIconSVG";
import { TableTopTypeEnum } from "../../../utils/enums/TableTopTypeEnum";

const TableTop = ({
    title,
    count,
    open,
    setOpen,
    variant = TableTopTypeEnum.FILLED
}) => {
    const getMainContainerStyle = () => {
        if (variant === TableTopTypeEnum.FILLED) {
            return styles.mainContainer;
        };

        if (variant === TableTopTypeEnum.TRANSPARENT) {
            return {
                ...styles.mainContainer,
                backgroundColor: "transparent",
                border: undefined
            };
        };
    };

    const GetEndArrowComponent = () => {
        let JSX;

        if (open) {
            JSX = (
                <div
                    style={styles.arrowContianer}
                    onClick={() => setOpen(false)}
                >
                    <TableHideArrowIconSVG />
                </div>
            );
        };

        if (!open) {
            JSX = (
                <div
                    style={styles.arrowContianer}
                    onClick={() => setOpen(true)}
                >
                    <TableShowArrowIconSVG />
                </div>
            );
        };

        return JSX;
    };


    const fullTitle = `${title} (${count})`;

    return (
        <div style={getMainContainerStyle()}>
            <p style={styles.titleText}>
                {fullTitle}
            </p>

            {
                variant === TableTopTypeEnum.FILLED && (
                    GetEndArrowComponent()
                )
            }
        </div>
    );
};


export default TableTop;

const styles = {
    mainContainer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: "#F3F4F6",
        border: "1px solid #CBD5E1",
        borderRadius: 2,
        paddingInline: 12,
        paddingTop: 4,
        paddingBottom: 4
    },
    titleText: {
        fontFamily: FontEnum.TITILIUM_WEB,
        fontWeight: 600,
        fontSize: "20px",
        color: "rgba(0, 0, 0, 0.87)"
    },
    arrowContianer: {
        cursor: 'pointer'
    }
};